import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgHeart from '../../svg/heart.svg'
import { IconProps } from '../icon-props'

const HeartIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgHeart
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-heart', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default HeartIcon
